import { saveAs } from 'file-saver'
import getImageNameFromUrl from './getImageNameFromUrl'

const BrowserDownloadHelper = (slide) => {
  const userAgent = navigator.userAgent
  const isNaverBrowser = userAgent.includes('NAVER')
  const isKakaoTalkInAppBrowser = userAgent.includes('KAKAOTALK')
  const formattedSlide = slide.src || slide
  const downloadName = getImageNameFromUrl(formattedSlide)

  if (isNaverBrowser || isKakaoTalkInAppBrowser) {
    const link = document.createElement('a')
    link.href = formattedSlide
    link.download = downloadName
    link.style.display = 'none'
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
    return
  } else {
    saveAs(formattedSlide, downloadName)
  }
}

export default BrowserDownloadHelper
